import { gql } from '@apollo/client';

export const GET_DEFAULT_SERVICE_PROVIDER_LAYOUT = gql`
  query GetDefaultServiceProviderLayout {
    layout: getDefaultServiceProviderLayout {
      id
      config {
        rows {
          sections {
            sectionTitle
            sectionSize
            columns {
              columnSize
              cards {
                cardTitle
                charts {
                  query
                  type
                  variables
                  formatData
                  width
                  height
                  legend
                  options
                }
              }
            }
          }
        }
      }
    }
  }
`;
